export function Cascade() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path
        d="M12 4 L5 20 L19 20 Z M12 8 L7.8 18.5 L16.2 18.5 Z"
        fillRule="evenodd"
      />
      <rect
        x="6.41"
        y="5.97"
        width="1.5"
        height="3"
        rx="0.75"
        transform="rotate(-45 7.16 7.47)"
      />
      <circle cx="5.21" cy="5.52" r="0.75" />
      <rect
        x="3.95"
        y="8.26"
        width="1.5"
        height="5"
        rx="0.75"
        transform="rotate(-45 4.7 10.76)"
      />
      <rect
        x="2.2"
        y="12.26"
        width="1.5"
        height="5"
        rx="0.75"
        transform="rotate(-45 2.95 14.76)"
      />
      <rect x="15.25" y="7.25" width="5" height="1.5" rx="0.75" />
      <rect x="17" y="11.25" width="5" height="1.5" rx="0.75" />
      <rect x="18.75" y="15.25" width="3" height="1.5" rx="0.75" />
      <circle cx="23" cy="16" r="0.75" />
    </svg>
  );
}
